import script from "./terminosYCondiciones.vue?vue&type=script&setup=true&lang=js"
export * from "./terminosYCondiciones.vue?vue&type=script&setup=true&lang=js"

import "./terminosYCondiciones.vue?vue&type=style&index=0&id=980fc26a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-980fc26a"]])

export default __exports__